export enum BLOB_UPLOAD_TYPE {
  DANCE_SCHOOL_LOGO = "DanceSchoolLogo",
  /**
   * The school's general mark. Deliberately DISTINCT from {@link DANCE_SCHOOL_LOGO} (the letterhead)
   * and the app logo: the API asserts the stored upload type on claim, so a separate type is what
   * stops a key minted for one slot being saved into another.
   */
  DANCE_SCHOOL_SCHOOL_LOGO = "DanceSchoolSchoolLogo",
  DANCE_SCHOOL_TERMS_AND_CONDITIONS = "DanceSchoolTermsAndConditions",
  DANCE_SCHOOL_EMAIL_ATTACHMENT = "DanceSchoolEmailAttachment",
  INVOICE_LOGO = "InvoiceLogo",
  TEACHER_NOTE_ATTACHMENT = "TeacherNoteAttachment",
  /**
   * A voice recording on a teacher note or one of its replies. Deliberately DISTINCT from
   * {@link TEACHER_NOTE_ATTACHMENT}: the upload path is chosen before the bytes are written and
   * cannot be changed later, so a separate type is what lets the API hold a voice note to being
   * audio (and stops a document being presented as one).
   */
  TEACHER_NOTE_VOICE_NOTE = "TeacherNoteVoiceNote",
  /** A file pinned to a studio notice. */
  NOTICE_ATTACHMENT = "NoticeAttachment",
  /**
   * A logo drawn for the mobile app, as opposed to {@link DANCE_SCHOOL_LOGO}, which is drawn for
   * invoices and documents. Distinct on purpose: the upload type is fixed when the bytes are
   * written, and it is what stops a letterhead wordmark being installed as the app's header mark
   * (or vice versa) by sending the wrong key.
   */
  DANCE_SCHOOL_APP_LOGO = "DanceSchoolAppLogo",
  /**
   * A mark drawn to be read inside a SQUARE — the app's dance school directory and school picker,
   * this portal's header mark and school switcher. Distinct from the three logos above for the same
   * reason they are distinct from each other: the API asserts the stored upload type on claim, so a
   * wide letterhead wordmark cannot be installed into the square slot by sending the wrong key.
   */
  DANCE_SCHOOL_SQUARE_LOGO = "DanceSchoolSquareLogo",
  /** A file a studio shares against a dance class. */
  DANCE_CLASS_FILE = "DanceClassFile",
  /**
   * The poster frame generated in the browser for a {@link DANCE_CLASS_FILE}. Distinct on purpose:
   * the upload type is fixed when the bytes are written, so a separate type is what holds a
   * thumbnail to being a small image and stops a 500MB video being written to the thumbnail path.
   */
  DANCE_CLASS_FILE_THUMBNAIL = "DanceClassFileThumbnail"
}

export interface IPreSignedBlobUrl {
  key: string;
  fileName: string;
  signedUrl: string;
  metadata: Record<string, string>;
}

export interface ICreateBlobUploadLinkRequest {
  uploadType: BLOB_UPLOAD_TYPE;
  fileName: string;
  contentType: string;
}